import { NgModule } from '@angular/core';
import { NoPreloading, PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { environment } from '../environments/environment';
import { AccountComponent } from './components/account/account.component';
import { AppComponent } from './components/app/app.component';
import { SecurityGuard } from './guards/security.guard';

const routes: Routes = [
  { path: '', redirectTo: 'app', pathMatch: 'full' },
  {
    path: 'app',
    component: AppComponent,
    canActivateChild: [SecurityGuard],
    loadChildren: () =>
      import('./modules/app-authenticated/app-authenticated.module').then(
        (m) => m.AppAuthenticatedModule,
      ),
  },
  {
    path: 'account',
    component: AccountComponent,
    loadChildren: () => import('./modules/account/account.module').then((m) => m.AccountModule),
  },
  // {
  //   path: 'widget',
  //   component: WidgetComponent,
  //   loadChildren: () => import('./modules/widget/widget.module').then((m) => m.WidgetModule),
  // },
  {
    path: 'b2c',
    loadChildren: () => import('./modules/b2c/b2c.module').then((m) => m.B2cModule),
  },
  {
    path: 'driver-location-view',
    loadChildren: () =>
      import('src/app/components/driver-location-view/driver-location-view.module').then(
        (m) => m.DriverLocationViewModule,
      ),
  },
  {
    path: 'views/route-recommendations/itinerary/:id',
    loadComponent: () =>
      import(
        'src/app/components/route-recommendations/route-itinerary/route-itinerary.component'
      ).then((m) => m.RouteItineraryComponent),
    data: { title: 'Route Itinerary' },
  },
  {
    path: 'generate-order-discount',
    loadChildren: () =>
      import(
        'src/app/components/generate-order-discount-code/generate-order-discount-code.module'
      ).then((m) => m.GenerateOrderDiscountCodeModule),
  },
  { path: '**', redirectTo: 'app' },
];

export function getEnableTracing(): boolean {
  return environment && environment.logging && environment.logging.level === 'TRACE';
}

export function getPreloadingStrategy() {
  return environment && environment.production ? PreloadAllModules : NoPreloading;
}

/**
 * Main routing module: Defines routes and loading strategy.
 *
 * Notes on refactoring during upgrade:
 *  - loadChildren above should end up as dynamic import syntax through ng upgrade.
 *  - Need to remove module definitions from tsconfig.app.json's files section for each child module.
 *  - Child module routes are also lazily loaded because app-authenticated is bulky.
 */
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      enableTracing: getEnableTracing(),
      preloadingStrategy: PreloadAllModules, //getPreloadingStrategy(),
      relativeLinkResolution: 'legacy',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
